export default {"src":"/_next/static/media/img-current-position.096883d1.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};